import { render, staticRenderFns } from "./ResultSetToCustomer.vue?vue&type=template&id=d8b80e50&scoped=true"
import script from "./ResultSetToCustomer.vue?vue&type=script&lang=js"
export * from "./ResultSetToCustomer.vue?vue&type=script&lang=js"
import style0 from "./ResultSetToCustomer.vue?vue&type=style&index=0&id=d8b80e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b80e50",
  null
  
)

export default component.exports